var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8V7.59073C2 6.44256 2.76842 5.41979 3.93684 5.01456L12.2947 2.12003C13.6 1.66656 15 2.55424 15 3.83748V6.5",
    stroke: "#2B328B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5588 13.9702V16.0302C21.5588 16.5802 21.1188 17.0302 20.5588 17.0502H18.5988C17.5188 17.0502 16.5288 16.2602 16.4388 15.1802C16.3788 14.5502 16.6188 13.9602 17.0388 13.5502C17.4088 13.1702 17.9188 12.9502 18.4788 12.9502H20.5588C21.1188 12.9702 21.5588 13.4202 21.5588 13.9702Z",
    stroke: "#2B328B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12H14",
    stroke: "#2B328B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.5H18C19.933 6.5 21.5 8.067 21.5 10V17.5C21.5 19.433 19.933 21 18 21H5C3.067 21 1.5 19.433 1.5 17.5V10C1.5 8.067 3.067 6.5 5 6.5Z",
    stroke: "#2B328B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.392f66d3.svg";
export { ForwardRef as ReactComponent };